import { Injectable } from '@angular/core';
import { BaseComponent } from '@wms/app/components';
import { BaseVariableService, VARIABLE_CONSTANTS } from '@wms/variables';
import { filter, forEach } from 'lodash-es';
import { ServiceFactoryService } from '@wms/app/services';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WmsWebsocketVariableService extends BaseComponent {
  PROPERTY = {
    'SERVICE': 'service',
    'DATA_UPDATE_STRATEGY': 'dataUpdateStrategy',
    'DATA_UPDATE_AT': 'dataUpdateAt',
    'DATA_LIMIT': 'dataLimit'
  };
  DATA_UPDATE_STRATEGY = {
    'REFRESH': 'refresh',
    'PREPEND': 'prepend',
    'APPEND': 'append'
  };
  propertyGroupChangeSubject = new Subject();

  constructor(private baseVariableService: BaseVariableService, private serviceFactory: ServiceFactoryService) {
    super();
  }

  __getVariableDependencies() {
    /*get the list of services available and append the options for service property*/
    (this.serviceFactory.getServicesWithType() as Promise<any>).then((services: any) => {
      services = filter(services, { type: VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET });
      services.sort((prevItem: any, currentItem: any) => prevItem.name.localeCompare(currentItem.name));

      /*push the services in the options list for the respective property selectbox*/
      this.baseVariableService.selectedVariable.propertyObj.service.options = {};
      forEach(services, (serviceObj) => {
        this.baseVariableService.selectedVariable.propertyObj.service.options[serviceObj.name] = serviceObj.name;
      });

      /*append the options for operations property based on selected service property*/
      this.__onPropertyChange(this.PROPERTY.SERVICE, undefined, true);
      //$scope.wmvariables.__onPropertyChange('appendData', undefined, true);
      this.__onPropertyChange(this.PROPERTY.DATA_UPDATE_STRATEGY, undefined, true);
    });
  }

  /*function to handle property change for a variable*/
  __onPropertyChange(propertyName: any, value?: any, initFlag?: any) {
    if (!initFlag) {
      this.baseVariableService.markUpdated();
    }

    switch (propertyName) {
      case this.PROPERTY.SERVICE:
        this.__onServiceChange(initFlag);
        break;
      case this.PROPERTY.DATA_UPDATE_STRATEGY:
        this.__onDataUpdateStrategyChange();
        break;
      case this.PROPERTY.DATA_LIMIT:
        this.__onDataLimitChange();
        break;
    }

    /*executing the event change method to create callback variables.*/
    if (VARIABLE_CONSTANTS.EVENTS.indexOf(propertyName) > -1) {
      this.baseVariableService.onEventChange(propertyName, value);
    }
  };

  //Show warning when there is no record limit set
  __onDataLimitChange() {
    let dataLimit = this.baseVariableService.selectedVariable.variableObject.dataLimit;
    if (dataLimit < 1) {
      // TO DO
      // $scope.toggleMessage(true, $rootScope.locale.MESSAGE_ERROR_INVALID_DATALIMIT, 'warn');
    } else {
      // TO DO
      // $scope.toggleMessage(false);
    }
  }

  __onDataUpdateStrategyChange() {
    let targetProperties = [this.PROPERTY.DATA_LIMIT],
      show = this.baseVariableService.selectedVariable.variableObject[this.PROPERTY.DATA_UPDATE_STRATEGY] !== this.DATA_UPDATE_STRATEGY.REFRESH;
    forEach(targetProperties, (property) => {
      this.baseVariableService.selectedVariable.propertyObj[property].hide = !show;
    });
    this.propertyGroupChangeSubject.next(true);
  }

  __onServiceChange(initFlag: any) {
    let selectedService,
      selectedVariable = this.baseVariableService.selectedVariable;
    selectedService = selectedVariable.variableObject[this.PROPERTY.SERVICE];

    /*check value sanity*/
    if (!selectedService) {
      return;
    }

    /*get the list of operations for the selected service*/
    this.serviceFactory.getServiceOperationParams(selectedService, undefined).then((operation: any) => {
      if (!initFlag) {
        /*initialize the data binding object for the variable*/
        selectedVariable.variableObject.dataBinding = [];
      }
      /* set the type of the variable to the return type of the operation */
      selectedVariable.variableObject.operation = operation.name;
      selectedVariable.variableObject.operationId = operation.operationId;
      selectedVariable.variableObject.type = operation.return.typeRef;
      selectedVariable.variableObject.isList = operation.isList || false;

      let testParams: any = [];

      forEach(operation.parameter, (param) => {
        testParams.push({
          'target': param.name,
          'type': param.typeRef,
          'format': param.format,
          'isList': param.isList
        });
      });
      this.baseVariableService.prepareBindings(testParams);

      /* add prepared bindings to the property object for display */
      this.baseVariableService.addBindingsToProperties();
    });
    this.baseVariableService.sourceExists();
    this.propertyGroupChangeSubject.next(true);
  }
}
